// extracted by mini-css-extract-plugin
export default {"wrapper":"NoticesList_wrapper__Zf+zK","galery":"NoticesList_galery__AAVau","galery__item":"NoticesList_galery__item__hZOyi","pagination":"NoticesList_pagination__qZTFk"};